import type { ActionFunctionArgs } from "@remix-run/node"
import { Form, Link, useActionData } from "@remix-run/react"
import { useState } from "react"
import { prettyPrintJson } from "pretty-print-json"
import { log } from "~/utils/common"
import { withIndexerAPI } from "~/utils/withIndexerAPI"
import { fullIndexReadTime } from "~/features/readTime/indexReadTime"

export const action = async ({ request }: ActionFunctionArgs) =>
  withIndexerAPI(request, async () => {
    try {
      const result = await fullIndexReadTime()

      log(`total runtime: ${result.totalRuntime}`)
    } catch (error) {
      log("Error running full video duration indexer:", error)
    }
  })

export default function Index() {
  const actionData = useActionData<typeof action>()

  const [isRunning, setIsRunning] = useState(false)

  const activeMessage = "indexer is currently running"

  const inactiveMessage = "inactive"

  if (actionData && isRunning === true) {
    setIsRunning(false)
  }

  const CompletionStateDescription = () => {
    if (typeof actionData === "object") {
      if ("message" in actionData) {
        return (
          <div>
            <span style={{ color: "red", fontSize: 24 }}>
              {`success: ${actionData.success} message: ${actionData.message}`}
            </span>
          </div>
        )
      } else {
        return (
          <pre
            dangerouslySetInnerHTML={{
              __html: prettyPrintJson.toHtml(actionData),
            }}
          />
        )
      }
    }

    if (typeof actionData === "string") {
      return (
        <div>
          <span>{actionData}</span>
        </div>
      )
    }

    return null
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          padding: "20px",
          border: "1px solid #ccc",
          borderRadius: "px",
          backgroundColor: "#fff9ec",
        }}
      >
        <>
          <Link to="/">Home</Link>
          <h1 style={{ textAlign: "center" }}>
            Contentful `Read Time` indexer for Posts, Articles, & Guides
          </h1>
          <div style={{ backgroundColor: "#e6fff7", padding: "15px" }}>
            <h4 style={{ margin: 0, marginBottom: 10 }}>Indexer State: </h4>
            <p>{isRunning ? activeMessage : inactiveMessage}</p>
            <CompletionStateDescription />
          </div>
          <Form method="post" onSubmit={() => setIsRunning(true)}>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <li style={{ marginRight: "20px" }}>
                <label>
                  Secret:
                  <input
                    name="secret"
                    type="text"
                    style={{ marginLeft: "10px" }}
                  />
                </label>
              </li>
              <li>
                <input
                  value="Start Indexer"
                  type="submit"
                  style={{ padding: "10px" }}
                />
              </li>
            </ul>
          </Form>
        </>
      </div>
    </div>
  )
}
